import { useContext } from 'react';
import { DoubleSide } from 'three';

import { GameContext } from '@/state/contexts';

const Card3DBackMemo = ({ texture, viewCardModal }) => {
	const scale = 1.1;
	const playerMatWidth = 2.5 * scale;
	const playerMatHeight = 3.5 * scale;

	const pc = useContext(GameContext);

	if (!pc) return;

	return (
		<group>
			<mesh
				visible
				userData={{ hello: 'world' }}
				position={[0, 5, 15]}
				rotation={[-0.64, 0, 0]}
				onClick={(e) => {
					e.stopPropagation();
					viewCardModal();
				}}
			>
				<boxGeometry args={[playerMatWidth, 0.1, playerMatHeight]} />
				<meshBasicMaterial
					attach="material"
					map={texture}
					side={DoubleSide}
				/>
			</mesh>
		</group>
	);
};

export default Card3DBackMemo;
